import { User } from "@/models/user";

const _token = `v-acms::token`
const _user = `v-acms::user`

const setToken = (token) => {
  localStorage.setItem(_token, JSON.stringify(token));
}

const getToken = () => {
  const token = localStorage.getItem(_token);
  if (token) {
    return JSON.parse(token)
  } else {
    return null
  }
}

const removeToken = () => {
  localStorage.removeItem(_token)
}

const setUser = (user) => {
  localStorage.setItem(_user, JSON.stringify(user));
}

const getUser = () => {
  const user = localStorage.getItem(_user);
  if (user) {
    return new User(JSON.parse(user))
  } else {
    return null
  }
}

const removeUser = () => {
  localStorage.removeItem(_user)
}

export default { setToken, getToken, removeToken, setUser, getUser, removeUser }